import React from "react";
import { post } from "utils/api";
import { sortInsurances } from "features/bonafide/helpers";
import { useDispatch } from "react-redux";
import {
  invalidatePatientProfileInfo,
  fetchPatientProfileInfo
} from "actions/patient";

const ACCESS_DENIED = "Access denied.";

const useBonafide = ({ patientId, uses_bonafide_api }) => {
  const dispatch = useDispatch();
  const [bonafidePatientInfo, setBonafidePatientInfo] = React.useState({
    companyInsurances: [],
    lmns: [],
    insurances: [],
    priors: [],
    patientId
  });
  const [errors, setErrors] = React.useState({
    lmns: null,
    insurances: null,
    companyInsurances: null,
    priors: null
  });
  const [isFetching, setIsFetching] = React.useState(null);
  React.useEffect(() => {
    if (uses_bonafide_api && patientId) getPatientInfo(patientId);
  }, [patientId, uses_bonafide_api]);
  async function getPatientInfo() {
    try {
      setIsFetching(true);
      const {
        companyInsurancesResponse,
        lmnResponse,
        guarantorResponse,
        priorAuthResponse,
        patientUpdated
      } = await post("bonafide/patient-info", {
        patientId
      });
      const patientInfo = {
        companyInsurances:
          companyInsurancesResponse.status === "success"
            ? companyInsurancesResponse.insurances
            : [],
        lmns: lmnResponse.status === "success" ? lmnResponse.LMNs : [],
        insurances:
          guarantorResponse.status === "success"
            ? sortInsurances(guarantorResponse.insurances)
            : [{ insurance: "", memberno: "" }],
        priors:
          priorAuthResponse.status === "success" ? priorAuthResponse.priors : []
      };
      setErrors({
        companyInsurances:
          companyInsurancesResponse.status !== "success"
            ? companyInsurancesResponse.errorMsg
            : null,
        lmns: lmnResponse.status !== "success" ? lmnResponse.errorMsg : null,
        insurances:
          guarantorResponse.status !== "success"
            ? guarantorResponse.errorMsg
            : null,
        priors:
          priorAuthResponse.status !== "success"
            ? priorAuthResponse.errorMsg
            : null
      });
      setBonafidePatientInfo({ ...patientInfo, errors, patientId });
      if (patientUpdated) {
        dispatch(invalidatePatientProfileInfo({ patientId }));
        dispatch(fetchPatientProfileInfo({ patientId }));
      }
    } catch (error) {
      // S3DEV2-7704: the panels already render errors.*; other failures keep the existing (silent) behavior.
      if (error?.status === 403)
        setErrors({
          lmns: ACCESS_DENIED,
          insurances: ACCESS_DENIED,
          companyInsurances: ACCESS_DENIED,
          priors: ACCESS_DENIED
        });
    } finally {
      setIsFetching(false);
    }
  }

  return {
    bonafidePatientInfo,
    errors,
    isFetching
  };
};

export default useBonafide;

export const BonafidePatientContext = React.createContext();
